import React, { FC, useMemo } from 'react';
import * as classes from './ServicesCarousel.module.scss';
import { CarouselItemI } from '../../../../../../interfaces/CarouselItemI';
import ServicesCarouselItem from './ServicesCarouselItem/ServicesCarouselItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import { getSlideColor } from '../../../../../../utils/getSlideColor';
import cn from 'classnames';

SwiperCore.use([Navigation]);

interface Props {
  items: Array<CarouselItemI>;
  slideClickAction: (id: string) => void;
}

const ServicesCarousel: FC<Props> = ({ items, slideClickAction }) => {
  const carouselItems = useMemo(() => {
    return items.map((item, index) => {
      return (
        <SwiperSlide key={item.id}>
          <ServicesCarouselItem
            title={item.title}
            image={item.image}
            action={() => slideClickAction(item.id)}
            id={item.id}
            bgColor={getSlideColor(index)}
          />
        </SwiperSlide>
      );
    }, []);
  }, [items, slideClickAction]);

  return (
    <div className={cn(classes.sliderWrapper, 'swiper-default-template')}>
      <Swiper slidesPerView='auto' spaceBetween={0} navigation={true}>
        {carouselItems}
      </Swiper>
    </div>
  );
};

export default ServicesCarousel;
